import React from "react";
import { Modal } from "react-bootstrap";
import Back from "assets/images/svg/back_blue.svg";
import Input from "components/input-fields/input-fields";
import { useParams } from "react-router-dom";
import { useLicenses } from "hooks/use-products";
import { Button, Form, InputField, SelectField } from "components/form";
import { MenuItem } from "@mui/material";
import _productService from "services/products-services";
import { toast } from "react-toastify";
import { t } from "i18next";
import { useQueryClient } from "react-query";
const ActivationFile = ({ show, onHide,addOnId, ...props }) => {
  const { id } = useParams();
  const { licenses, isLoading } = useLicenses(id);
  const queryClient = useQueryClient()

  const success = () => {
    onHide();
    toast.success(t('common:form.generated'))
    queryClient.invalidateQueries(['products-addon'])
    queryClient.invalidateQueries(['addon-details'])

  };


  const handleRequest = (data) => {
      const renewActive={
        versionSubscriptionId: id,
        addOnSubscriptionId: addOnId,
        licenseId: data?.deviceName
      }
    _productService.renewAddonActivationLicense(renewActive).then(({response})=>{
     if(response) success()
    })
  };

  const getSerialNum = (id) => {
    return licenses?.find((l) => l.id === id)?.serialNumber;
  };
  return (
    <div>
      <Modal
        {...props}
        size="lg"
        aria-label="contained-modal-title-vcenter"
        centered
        show={show}
        onHide={onHide}
        className="all-modal"
      >
        <Modal.Body>
          <div className="header">
            <img src={Back} alt="back" onClick={onHide} />
            <h1>ADDON TITLE</h1>
          </div>
          <Form className="row" onSubmit={handleRequest} defaultValues={{}}>
            {({ watch }) => {
              return (
                <>
                  <div className="col-md-12">
                    <SelectField label="Device Name" id="deviceName" rules={{ required: "errors:required" }}>
                      {licenses.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                          {option.deviceName}
                        </MenuItem>
                      ))}
                    </SelectField>
                    <InputField
                      label="Serial Number"
                      id="serialNumber"
                      value={getSerialNum(watch("deviceName"))}
                      disabled
                      readonly
                    />
                  </div>
                  <div className="col-12">
                    <Button type="submit" className="btn-blue mt-4" isLoading={isLoading}>
                      Generate
                    </Button>
                  </div>
                </>
              );
            }}
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ActivationFile;
